import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";
import { format } from "date-fns";

import { AiOutlinePrinter } from "react-icons/ai";

import { MenuItem, Text } from "@chakra-ui/react";

import ServicoAcolhimentoService from "../../../main/services/ServicoAcolhimentoService";

import { ComponentToPrint } from "../ComponentToPrint";
import { API } from "../../../main/config";

export const PrintMenuItem = ({ idSA }) => {
  const componentToPrintRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();

  const beforeGetContent = async () => {
    setIsLoading(true);
    try {
      const res = await ServicoAcolhimentoService.dadosImpressao(idSA);
      const { planejamentoServicoAcolhimento, servicoAcolhimento, ...resto } =
        res.data;

      const tempPlanejamento = planejamentoServicoAcolhimento
        ? [
            {
              documento: "Plano de Trabalho",
              data:
                res.data.planejamentoServicoAcolhimento.possuiPlanoTrabalho ===
                "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataAtualizacaoPlanoTrabalho
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoPlanoTrabalho,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Projeto Político-Pedagógico",
              data:
                res.data.planejamentoServicoAcolhimento.possuiPPP === "S"
                  ? res.data.planejamentoServicoAcolhimento.dataAtualizacaoPPP
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoPPP,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Relatório Anual",
              data:
                res.data.planejamentoServicoAcolhimento.possuiRelatorioAnual ===
                "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataApresentacaoRelatorio
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataApresentacaoRelatorio,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Regimento Interno",
              data:
                res.data.planejamentoServicoAcolhimento
                  .possuiRegimentoInterno === "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataAtualizacaoRegimento
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoRegimento,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
          ]
        : null;
      setData({
        planejamentoServicoAcolhimento: tempPlanejamento,
        servicoAcolhimento: {
          linkImagem:
            API + `/servico-acolhimento/logo/${servicoAcolhimento.id}`,
          ...servicoAcolhimento,
        },
        ...resto,
      });
      setIsLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const customPageStyle = `
    @page { 
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 10mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setIsLoading(false)}
        pageStyle={customPageStyle}
        trigger={() => {
          return (
            <MenuItem color={"#374BCE"} p={2}>
              <AiOutlinePrinter />
              <Text ml="5px">Imprimir</Text>
            </MenuItem>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        {!isLoading && (
          <ComponentToPrint
            idSA={idSA}
            ref={componentToPrintRef}
            dataSA={data ? data.servicoAcolhimento : null}
            dataPerfil={data ? data.perfilServicoAcolhimento : null}
            dataGestao={data ? data.gestaoServicoAcolhimento : null}
            dataRegularidade={data ? data.regularidadeServicoAcolhimento : null}
            dataPlanejamento={data ? data.planejamentoServicoAcolhimento : null}
            dataEquipe={data ? data.membros : null}
            dataRedeReferencia={data ? data.redeReferencia : null}
            dataVoluntariado={data ? data.voluntariados : null}
            dataPessoaEmCumprimento={data ? data.pessoas : null}
            dataFamiliaAcolhedora={data ? data.familias : null}
            dataAnexos={data ? data.anexos : null}
            dataPendencias={data ? data.pendencias : null}
            dataProgramaApadrinhamento={
              data ? data.programaApadrinhamento : null
            }
          />
        )}
      </div>
    </>
  );
};
